<template>
  <div >

          <div class="md-layout" v-if="loading">
                 
                  <div class="md-layout-item md-size-100">
                        <md-progress-spinner  :md-diameter="30" md-mode="indeterminate"></md-progress-spinner> {{msg_status}} ..
                  </div>
         </div>

         
         <div class="scroll_unidade">
         Clientes / Unidades Selecionadas ( {{items.qtde}} )
           <ul v-if="items.clientes != null && items.clientes != undefined">
                    <li v-for="(item, index) in items.clientes" :key="index">
                           
                                      <b>{{item.cliente.nome_cliente}}</b>
                                      <div >
                                          <ul>
                                                            <li v-for="(item_sub, index_sub) in item.unidades" :key="index_sub"  class="collection-item" >

                                                                             <div > {{item_sub.descricao}} 
                                                                                    <md-button style="display:none"
                                                                                                class="md-just-icon md-info md-simple secondary-content pull-right"
                                                                                                @click.native="excluir(item_sub, index_sub)"
                                                                                                >
                                                                                                <md-icon>remove_circle</md-icon>
                                                                                    </md-button>
                                                                                      <button  class="md-button md-just-icon md-info md-simple" 
                                                                                         style="height: auto; font-size: 12px; line-height: 20px;" @click="excluir(item_sub, index_sub)">
 
                                                                                                <md-icon>remove_circle</md-icon>
                                                                                        </button>
                                                                                    </div>
                                                                       
                                                                        
                                                             </li>

                                               </ul>
                                          
                                      </div>
                            </li>

                    </ul>
         </div>

</div>
</template>
<style>
.scroll_unidade{

    max-height: 250px;
    overflow-y: scroll;
    overflow-x: scroll;
}

</style>
<script>

import service from "../../../services/EstabelecimentoService";


    export default {
        props: ['id_start_value','id_usuario','onRemove'],
        model: {
            prop: 'id_start_value',
            event: 'blur'
        },
         data: function() {
            return {
              items: [],
                 items_selected: [],

                 loading: true,
                 msg_status: "Carregando",
                 disableButton: false,
                }     
        },
        watch: {
            id_start_value: function (val ){
                          this.items_selected = this.id_start_value.toString().split(',');
                          this.loadData();


            },
       },
        methods: {
            
                     loadData(){


                                        let self = this;
                                        this.loading = true;

                                        this.disableButton = true;   

                                        var data = { }

                                        if ( this.items_selected.length > 0 ){

                                                        
                                                    service.getListByIds(  this.items_selected.join(',')   ).then(function (response){
                                                                    console.log( response.data );

                                                                    self.items = response.data;
                                                                    self.disableButton = false;
                                                                    self.loading = false;
                                                    }).catch(function(error){
                                                        console.log( JSON.parse(  JSON.stringify(error)));
                                                    });

                                        }else {
                                            
                                                                    self.items = [];
                                                                    self.disableButton = false;
                                                                    self.loading = false;
                                        }



                     },
                            temEstaId(id){


                                if ( this.id_start_value != null && this.id_start_value != undefined ){
                                            if ( this.id_start_value.toString().split(',').indexOf(id.toString() ) > -1 ){
                                                return true;
                                            }
                                }

                                return false;

                            },
                            fn_seleciona_todos(){
                                
                                    if ( this.seleciona_todos ){
                                        var ar = [];

                                        for ( var i = 0; i < this.items.length; i++ ){
                                            ar[i] = this.items[i][field_value];
                                        }

                                        this.items_selected = ar;

                                    }else{

                                    }
                                        this.items_selected = [];
                            },

                            seleciona(ev){

                                var valor = ev.target.value;
                                var checked =  ev.target.checked;

                                if ( this.items_selected.indexOf(valor.toString() ) > -1 ){ //Já existe.

                                            if ( !checked ){ //Foi desmarcado..

                                                    this.items_selected.splice( valor , 1 );
                                            }

                                        } else {

                                            if ( checked ){
                                                this.items_selected.push( valor );
                                            }
                                }
                                    
                                this.$emit('blur', this.items_selected.join(','));
                                if ( this.onSelect != null && this.onSelect != undefined ){
                                    this.onSelect(this.items_selected);
                                }
                            },
                            add(){

                            },
                            excluir( item, index ){

                                if ( this.items_selected == undefined )
                                 {
                                      console.log("indefinido");
                                      console.log(this);
                                      return;
                                 }

                                 if ( this.items_selected.indexOf(item.id.toString() ) > -1 ){

                                        if ( this.onRemove != null && this.onRemove != undefined ){

                                             this.onRemove(item, item.id.toString());

                                        }else{

                                                     var indx = this.items_selected.indexOf(item.id.toString() ) ;

                                                     this.items_selected.splice( indx , 1 );

                                                     this.loadData();

                                                     this.$emit('blur', this.items_selected.join(','));
                                            
                                        }

                                                    
                                  }

                                          
                            }
        },
        mounted() {

            
                                        if ( this.id_start_value == null || this.id_start_value == undefined ){
                                            this.loading = false;
                                            return;
                                        }

                                        this.items_selected = this.id_start_value.toString().split(',');

                     this.loadData();
                
  
        }
    }
    </script>                